import { AddressModel, address } from './address'
import { AuthModel, auth } from './auth'
import { CheckoutModel, checkout } from './checkout'
import { DataModel, data } from './data'
import { FeeModel, fee } from './fee'
import { HistoryModel, history } from './history'
import { PayModel, pay } from './pay'
import { PaymentModel, payment } from './payment'
import { ProductModel, product } from './product'
import { TrackDeliveryModel, trackDelivery } from './track_delivery'
import { UnsubscribeModel, unsubscribe } from './unsubscribe'
import { UpdateModel, update } from './update'
import { ValidateModel, validate } from './validate'

export interface SubscriptionModel {
	address: AddressModel
	auth: AuthModel
	checkout: CheckoutModel
	data: DataModel
	fee: FeeModel
	history: HistoryModel
	pay: PayModel
	payment: PaymentModel
	product: ProductModel
	trackDelivery: TrackDeliveryModel
	unsubscribe: UnsubscribeModel
	update: UpdateModel
	validate: ValidateModel
}

export const subscription: SubscriptionModel = {
	address,
	auth,
	checkout,
	data,
	fee,
	history,
	pay,
	payment,
	product,
	trackDelivery,
	unsubscribe,
	update,
	validate
}
